// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__299er","label":"styles_label__mSJbA"};